import React, { useEffect } from "react";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AppBar from "@material-ui/core/AppBar";
import styles from "../styles/components/NavigationDrawer.module.css";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import PersonIcon from "@material-ui/icons/Person";
import {Menu, MenuItem, Typography} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { navigationElements } from "../helpers/navigationElements";
import clsx from "clsx";
import breakpoints from "../styles/Breakpoints.module.css";
import useMediaQuery from "../hooks/useMediaQuery";
import find from "lodash/find";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {isLoggedInState, userState} from "../state/userState";
import {logOutRequest} from "../rest/clientV2";
import * as O from 'fp-ts/Option';

export const NavigationDrawer: React.FC = props => {
  const history = useHistory();
  const isLoggedIn = useRecoilValue(isLoggedInState)
  const isMobileScreen = useMediaQuery(breakpoints.sm);
  const [state, setState] = React.useState(!isMobileScreen && isLoggedIn);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const setUser = useSetRecoilState(userState)


  useEffect(() => {
    setState(!isMobileScreen && isLoggedIn);
  }, [isMobileScreen, setState, isLoggedIn]);

  const openMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const signOut = async () => {
     await logOutRequest();
     setUser(O.none)
  };

  const signIn =  () => {
    handleClose()
    history.push("/sign-in")
  }

  const UserMenu = () => (
    <Menu
      id="user-menu"
      anchorEl={anchorEl}
      getContentAnchorEl={null}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      PaperProps={{style: {width: 150}}}>
      {isLoggedIn
        ? [
          <MenuItem
            key="Log Out"
            onClick={() => {
              handleClose();
              signOut();
            }}>
            Log Out
          </MenuItem>
        ]
        : [
          <MenuItem key="SignInItem" onClick={signIn}>
            Sign In
          </MenuItem>
        ]}
    </Menu>
  );


  const toggleDrawer = (open: boolean) => (
    event: React.KeyboardEvent | React.MouseEvent
  ) => {
    if (
      event &&
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" ||
        (event as React.KeyboardEvent).key === "Shift")
    ) {
      return;
    }

    if (!isLoggedIn) {
      return;
    }

    setState(open);
  };

  const currentElement = find(
    navigationElements,
    ne => ne.path === history.location.pathname
  );

  const getElements = () => (
    <div
      className={styles.fullList}
      role="presentation"
      //onClick={toggleDrawer(false)}
      //onKeyDown={toggleDrawer(false)}
    >
      <List>
        {navigationElements.map((el, index) => (
          <ListItem
            className={
              currentElement?.path === el.path
                ? styles.selectedItem
                : styles.item
            }
            button
            selected={currentElement?.path === el.path}
            key={index}
            onClick={() => history.push(el.path)}
          >
            {el.icon && <ListItemIcon>{el.icon}</ListItemIcon>}
            <ListItemText primary={el.title} />
          </ListItem>
        ))}
      </List>
    </div>
  );


  return currentElement ? (
    <div className={styles.navigation}>
      <AppBar
        position="fixed"
        className={state ? styles.openAppBar : styles.closedAppBar}
      >
        <Toolbar className={styles.toolbar}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer(!state)}
            edge="start"
            className={styles.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            {currentElement.title}
          </Typography>
          <div style={{marginLeft: 'auto'}}>
            <IconButton color="inherit" onClick={openMenu}><PersonIcon /></IconButton>
          </div>
          <UserMenu />
        </Toolbar>
      </AppBar>
      <SwipeableDrawer
        className={styles.drawer}
        variant="persistent"
        anchor="left"
        open={state}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <div className={styles.logo}>
        </div>
        {getElements()}
      </SwipeableDrawer>
      <div className={clsx(styles.pageWrapper, state && styles.openDrawerPage)}>
        {props.children}
      </div>
    </div>
  ) : (
    <>{props.children}</>
  );
};
